'use strict';

// export this package's api
module.exports = require('./Pagination');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.6.1@rc-pagination/lib/index.js
 ** module id = 408
 ** module chunks = 0
 **/